import { render, staticRenderFns } from "./ModelList.vue?vue&type=template&id=ce6f0176"
import script from "./ModelList.vue?vue&type=script&lang=js"
export * from "./ModelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports